import React from 'react';
import "../LandingPage.css";
import { Card } from 'antd';


const PrivacyPage = () => {
  return (
    <div style={{ paddingLeft: "20px", paddingRight: "20px", paddingBottom: "60px", paddingTop: "60px" }}>
    <Card 
    style={{
      marginTop: "60px",
      marginBottom: "60px",
      maxWidth: 800,
      margin: "auto", // Centers the card
      minWidth: 280,
      textAlign: "left",
      boxShadow: "0 8px 16px rgba(0,0,0,0.1)"
    }}>
    <div style={{ padding:"20px", maxWidth: '800px', margin: '0 auto' }}>
      <h1>Personvernerklæring</h1>
      <p>Sist oppdatert: 1. februar 2025</p>

      <h3>1. Innledning</h3>
      <p>
        Denne personvernerklæringen forklarer hvordan Kipler AI ("vi", "oss" eller "vår") behandler
        personopplysninger i forbindelse med vår tjeneste for transkribering og analyse av samtaler. Vi er
        forpliktet til å beskytte personvernet til brukerne våre og sikre at data behandles i samsvar med gjeldende
        lover og forskrifter, inkludert personvernforordningen (GDPR).
      </p>

      <h3>2. Hvilke data samler vi inn?</h3>
      <ul>
        <li><strong>Lydopptak:</strong> Opptak av samtaler som lastes opp av brukeren.</li>
        <li><strong>Transkripsjoner:</strong> Tekstutdrag av samtaler generert ved hjelp av vår transkripsjonstjeneste.</li>
        <li><strong>Anonymiserte data:</strong> Transkripsjoner hvor person- og stedsnavn automatisk fjernes.</li>
        <li><strong>Analyser og anbefalinger:</strong> Data generert av AI for å gi tilbakemeldinger til brukeren.</li>
        <li><strong>Brukerdata:</strong> Informasjon som navn, e-postadresse og kontodetaljer for brukere.</li>
      </ul>

      <h3>3. Formål med datainnsamlingen</h3>
      <p>Vi behandler data for å:</p>
      <ul>
        <li>Tilby transkribering av samtaler.</li>
        <li>Anonymisere innhold for å sikre personvernet.</li>
        <li>Gi analyser og innsikt basert på samtalene.</li>
        <li>Levere journalnotater for dokumentasjonsformål.</li>
        <li>Forbedre våre tjenester gjennom kontinuerlig utvikling og maskinlæring.</li>
      </ul>

      <h3>4. Lagring og sletting av data</h3>
      <ul>
        <li>Lydopptak slettes automatisk etter transkribering.</li>
        <li>Transkripsjoner lagres i en sikker database og anonymiseres umiddelbart.</li>
        <li>Brukere kan selv be om sletting av lagrede transkripsjoner og analyser.</li>
        <li>Personopplysninger beholdes kun så lenge det er nødvendig for formålene nevnt ovenfor.</li>
      </ul>

      <h3>5. Deling av data</h3>
      <p>
        Vi deler ikke data med tredjeparter med mindre det er eksplisitt samtykket til eller kreves ved lov. Alle
        analyser og transkripsjoner behandles internt i vårt sikre system.
      </p>

      <h3>6. Sikkerhetstiltak</h3>
      <ul>
        <li>Kryptering av lydopptak og transkripsjoner.</li>
        <li>Tilgangskontroller som sikrer at kun autoriserte brukere kan hente ut informasjon.</li>
        <li>Regelmessige sikkerhetsoppdateringer og overvåking av systemer.</li>
      </ul>

      <h3>7. Brukerrettigheter</h3>
      <p>Brukere har rett til:</p>
      <ul>
        <li>Innsyn i hvilke data vi har lagret.</li>
        <li>Be om retting eller sletting av personopplysninger.</li>
        <li>Begrense eller protestere mot behandlingen av deres data.</li>
        <li>Få dataene overført til en annen tjenesteleverandør dersom det er teknisk mulig.</li>
      </ul>

      <h3>8. Endringer i personvernerklæringen</h3>
      <p>
        Vi kan oppdatere denne erklæringen for å reflektere endringer i våre tjenester eller gjeldende lover. Oppdateringer
        vil bli varslet til brukerne via vår nettside.
      </p>

      <h3>9. Kontaktinformasjon</h3>
      <p>
        Hvis du har spørsmål om hvordan vi behandler dine personopplysninger, kontakt oss på:
      </p>
      <p>
        E-post: <a href="mailto:post@kipler.ai">post@kipler.ai</a><br />
        Adresse: Sverdrups gate 21, 0559 Oslo
      </p>
    </div>
    </Card>
    </div>
  );
};

export default PrivacyPage;